import { PORTAL_COMPLIANCE_REGISTRY_SEARCH_FILTER_SOURCE } from 'domain/shared/employee';
import { Filter, getFilterValue, LoadingParams } from 'framework/list';
import { FilterCondition } from 'framework/types';

const mapSearchFilterForEmployeeScope = (filter: Filter) => {
  const searchString = filter?.[PORTAL_COMPLIANCE_REGISTRY_SEARCH_FILTER_SOURCE]?.eq;

  if (searchString) {
    delete filter?.[PORTAL_COMPLIANCE_REGISTRY_SEARCH_FILTER_SOURCE];
    filter.searchString = {
      ct: searchString,
    };
  }

  return filter;
};

const mapDocumentSearchToEntityId = (filter: Filter) => {
  const searchValue = getFilterValue<string>(filter, PORTAL_COMPLIANCE_REGISTRY_SEARCH_FILTER_SOURCE) || '';

  if (!searchValue) {
    return filter;
  }

  delete filter?.[PORTAL_COMPLIANCE_REGISTRY_SEARCH_FILTER_SOURCE];
  filter.entityId = {
    [FilterCondition.CT]: searchValue,
  };

  return filter;
};

export const buildComplianceSearchPayload = (requestParams: LoadingParams) => {
  const filter = { ...(requestParams.filter || {}) };
  const isEmployeeScopedRequest = !!filter?.alias;
  const asOfDate = filter?.asOfDate?.eq;
  delete filter?.asOfDate;

  if (isEmployeeScopedRequest) {
    mapDocumentSearchToEntityId(filter);
  } else {
    mapSearchFilterForEmployeeScope(filter);
  }

  return {
    searchRequest: {
      ...requestParams,
      sort: { ...(requestParams?.sort || {}), 'nameEn.lastName': 'ASC' },
      filter,
      asOfDate,
    },
  };
};
